import { render, staticRenderFns } from "./loginDistributor.vue?vue&type=template&id=0fda1b40&scoped=true&"
import script from "./loginDistributor.vue?vue&type=script&lang=js&"
export * from "./loginDistributor.vue?vue&type=script&lang=js&"
import style0 from "./loginDistributor.vue?vue&type=style&index=0&id=0fda1b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda1b40",
  null
  
)

export default component.exports